/**
 * 「機能利用」画面の数字・日付の書き方（Screen Contract `admin-ops-feature-usage`）。時刻はすべて JST。
 */

const JST_OFFSET_MS = 9 * 3_600_000;
const WEEKDAYS = ['日', '月', '火', '水', '木', '金', '土'];

/** `2026-09-24（水）`（U-3）。 */
export function dayWithWeekday(day: string): string {
  const w = new Date(`${day}T00:00:00Z`).getUTCDay();
  return `${day}（${WEEKDAYS[w]}）`;
}

/** 表の中の日付 `9/23`。 */
export function shortDay(day: string): string {
  const [, m, d] = day.split('-');
  return `${Number(m)}/${Number(d)}`;
}

/** 集計時点 `10:32`（U-10）。 */
export const jstTime = (iso: string) =>
  new Date(new Date(iso).getTime() + JST_OFFSET_MS).toISOString().slice(11, 16);

/** 滞在時間 `1 分 20 秒`。 */
export function formatDuration(ms: number): string {
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s} 秒`;
  const m = Math.floor(s / 60);
  const rest = s % 60;
  return rest === 0 ? `${m} 分` : `${m} 分 ${rest} 秒`;
}

/** 3 桁区切りの整数。 */
export const formatInt = (n: number) => n.toLocaleString('en-US');

/** 比較の差 `+3` / `−5` / `±0`（色を付けない・% を出さない）。 */
export function formatDiff(n: number, decimals = 0): string {
  const v = decimals > 0 ? Number(n.toFixed(decimals)) : n;
  if (v === 0) return '±0';
  const abs = decimals > 0 ? Math.abs(v).toFixed(decimals) : formatInt(Math.abs(v));
  return v > 0 ? `+${abs}` : `−${abs}`;
}

/** workspace の表示名（削除済みは U-35）。 */
export function workspaceName(ws: { workspaceId: string; name: string | null }): string {
  const id8 = ws.workspaceId.slice(0, 8);
  return ws.name === null ? `削除済み workspace（${id8}）` : `${ws.name}（${id8}）`;
}

/** 期間の日数（両端を含む）。 */
export function lengthOf(r: { fromDay: string; toDay: string }): number {
  return (
    Math.round(
      (Date.parse(`${r.toDay}T00:00:00Z`) - Date.parse(`${r.fromDay}T00:00:00Z`)) / 86_400_000,
    ) + 1
  );
}

/** `from` から `n` 日ずらした日。 */
export function shiftDay(day: string, n: number): string {
  return new Date(Date.parse(`${day}T00:00:00Z`) + n * 86_400_000).toISOString().slice(0, 10);
}
